import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { timelineApi } from 'api/timeline';
import { usePanel } from 'contexts/panelContext';
import { TimelineEventItem } from 'types/Timeline';
import { faltPaginatedTimelineDataAndSort, groupTimelineData } from './timeline.utils';

export const useTimelineSimple = () => {
	const { currentApplicationData } = usePanel();

	const { data, isLoading, isFetching, refetch } = useQuery(
		['TIMELINE_EVENTS_SIMPLE', { applicationId: currentApplicationData.id }],
		() => timelineApi.getTimelineEventsSimple(currentApplicationData.id),
		{
			enabled: true,
		}
	);

	return { data, isLoading, isFetching, refetch };
};

export const useTimeline = (eventId?: number | null) => {
	const { currentApplicationData } = usePanel();

	const {
		data,
		fetchPreviousPage,
		fetchNextPage,
		isFetchingNextPage,
		isFetchingPreviousPage,
		hasNextPage,
		hasPreviousPage,
		isFetching,
		refetch,
	} = useInfiniteQuery(
		['TIMELINE_EVENTS', { applicationId: currentApplicationData.id, eventId }],
		({ pageParam = 0 }) => timelineApi.getTimelineEventsPaged(currentApplicationData.id, eventId, pageParam),
		{
			enabled: true,
			getNextPageParam: (lastPage, pages) => (lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined),
			getPreviousPageParam: (prevPage, pages) => (prevPage.meta.hasPrevPage ? prevPage.meta.page - 1 : undefined),
			keepPreviousData: true,
		}
	);

	const finalData = faltPaginatedTimelineDataAndSort(data);
	const grouppedData = groupTimelineData(finalData);

	const updateData = (item: TimelineEventItem) => {
		const pageToRefetch = data?.pages.find(({ items }) => items.some(({ key }) => key === item.key))?.meta.page;
		if (pageToRefetch !== undefined) {
			refetch({
				refetchPage: (page: any) => {
					return page?.meta?.page === pageToRefetch;
				},
			});
		}
	};

	return {
		data: finalData,
		grouppedData,
		fetchNextPage,
		fetchPreviousPage,
		isFetchingNextPage,
		isFetchingPreviousPage,
		hasNextPage,
		hasPreviousPage,
		loading: isFetching,
		updateData,
	};
};
